import React, { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { getClientDomain, getToken, translate } from '../../../utils/Common';
import PackageDetails from './PackageDetails';
import PageContainer from '../../../components/layout/PageContainer';
import Button from '../../../components/common/Button/Button';
import * as FaIcons from 'react-icons/fa';
import styles from './PackageDetails/PackageDetail.module.css';

const PackageDetailStandalone = () => {
    const { packageId } = useParams();
    const history = useHistory();
    const location = useLocation();
    const match = useRouteMatch();
    const [packageData, setPackageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const listUrl = match?.url?.replace(/\/package\/[^/]+$/, '') || '/dashboard/packages/tracking';
    const fromSearch = location.state?.fromSearch || '';

    const fetchPackage = async () => {
        if (!packageId) {
            setError(translate('global.error') || 'Invalid package ID');
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/package/${packageId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${getToken()}`,
                },
            });
            const result = await response.json();
            if (result.code === 200 && result.payload?.length > 0) {
                setPackageData(result.payload[0]);
            } else {
                setError(translate('dashboard.packages.search.NOT_PACKAGE_FOUND') || 'Package not found');
            }
        } catch (err) {
            console.error(err);
            setError(translate('dashboard.packages.search.ERROR_SEARCH') || 'Error loading package');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackage();
    }, [packageId]);

    const handleCancelBusqueda = () => {
        history.push(listUrl + fromSearch);
    };

    const handleSelectedPackage = (updatedPackage) => {
        setPackageData(updatedPackage);
    };

    if (loading) {
        return (
            <PageContainer>
                <div className={styles.loadingContainer} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <div className="inline-block size-4 animate-spin rounded-full border-2 border-current border-r-transparent text-fucsia" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </PageContainer>
        );
    }

    if (error) {
        return (
            <PageContainer>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '300px', gap: '16px' }}>
                    <p>{error}</p>
                    <Button
                        variant="primary"
                        onClick={handleCancelBusqueda}
                        leftIcon={<FaIcons.FaArrowLeft />}
                    >
                        {translate('dashboard.packages.details.actions.backToPackages')}
                    </Button>
                </div>
            </PageContainer>
        );
    }

    if (!packageData) return null;

    return (
        <PackageDetails
            selectedPackage={packageData}
            packagesFound={[packageData]}
            handleSelectedPackage={handleSelectedPackage}
            handleCancelBusqueda={handleCancelBusqueda}
        />
    );
};

export default PackageDetailStandalone;
